import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import AreaVisitantes from './pages/AreaVisitantes';
import Medicamentos from './pages/Medicamentos';
import CadastroMedicamento from './pages/CadastroMedicamento';
import DetalhesGrupoMedicamento from './pages/DetalhesGrupoMedicamento';
import MedicamentosRegistrados from './pages/MedicamentosRegistrados';
import EditarMedicamentoRegistrado from './pages/EditarMedicamentoRegistrado';
import Pacientes from './pages/Pacientes';
import CadastroPaciente from './pages/CadastroPaciente';
import DetalhesPaciente from './pages/DetalhesPaciente';
import Liberacoes from './pages/Liberacoes';
import NovaLiberacao from './pages/NovaLiberacao';
import DetalhesLiberacao from './pages/DetalhesLiberacao';
import ReciboLiberacao from './pages/ReciboLiberacao';
import GestaoUsuarios from './pages/GestaoUsuarios';
import Relatorios from './pages/Relatorios';

// Componente para rotas protegidas
const ProtectedRoute = ({ children }) => {
  const { token, user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }
  
  if (!token) {
    return <Navigate to="/login" />;
  }

  // Redirecionar visitantes automaticamente para sua área
  if (user?.cargo === 'visitante' && window.location.pathname === '/') {
    return <Navigate to="/visitantes" replace />;
  }

  // Impedir visitantes de acessar outras áreas que não sejam /visitantes
  if (user?.cargo === 'visitante' && window.location.pathname !== '/visitantes') {
    return <Navigate to="/visitantes" replace />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppContent />
        </div>
      </Router>
    </AuthProvider>
  );
}

function AppContent() {
  const { token } = useAuth();
  const [sidebarExpanded, setSidebarExpanded] = useState(false);

  return (
    <>
      {token && <Sidebar 
        expanded={sidebarExpanded} 
        onToggle={() => setSidebarExpanded(!sidebarExpanded)} 
      />}
      <div className={`main-content ${token ? (sidebarExpanded ? 'with-sidebar-expanded' : 'with-sidebar-collapsed') : ''}`}>
        {token && <Navbar />}
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/visitantes" element={
            <ProtectedRoute>
              <AreaVisitantes />
            </ProtectedRoute>
          } />
          <Route path="/medicamentos" element={
            <ProtectedRoute>
              <Medicamentos />
            </ProtectedRoute>
          } />
          <Route path="/medicamentos/novo" element={
            <ProtectedRoute>
              <CadastroMedicamento />
            </ProtectedRoute>
          } />
          <Route path="/medicamentos/editar/:id" element={
            <ProtectedRoute>
              <CadastroMedicamento />
            </ProtectedRoute>
          } />
          <Route path="/medicamentos/grupos/detalhes" element={
            <ProtectedRoute>
              <DetalhesGrupoMedicamento />
            </ProtectedRoute>
          } />
          <Route path="/medicamentos-registrados" element={
            <ProtectedRoute>
              <MedicamentosRegistrados />
            </ProtectedRoute>
          } />
          <Route path="/medicamentos-registrados/editar/:id" element={
            <ProtectedRoute>
              <EditarMedicamentoRegistrado />
            </ProtectedRoute>
          } />
          <Route path="/pacientes" element={
            <ProtectedRoute>
              <Pacientes />
            </ProtectedRoute>
          } />
          <Route path="/pacientes/novo" element={
            <ProtectedRoute>
              <CadastroPaciente />
            </ProtectedRoute>
          } />
          <Route path="/pacientes/editar/:id" element={
            <ProtectedRoute>
              <CadastroPaciente />
            </ProtectedRoute>
          } />
          <Route path="/pacientes/detalhes/:id" element={
            <ProtectedRoute>
              <DetalhesPaciente />
            </ProtectedRoute>
          } />
          <Route path="/liberacoes" element={
            <ProtectedRoute>
              <Liberacoes />
            </ProtectedRoute>
          } />
          <Route path="/liberacoes/nova" element={
            <ProtectedRoute>
              <NovaLiberacao />
            </ProtectedRoute>
          } />
          <Route path="/liberacoes/detalhes/:id" element={
            <ProtectedRoute>
              <DetalhesLiberacao />
            </ProtectedRoute>
          } />
          <Route path="/liberacoes/recibo/:id" element={
            <ProtectedRoute>
              <ReciboLiberacao />
            </ProtectedRoute>
          } />
          <Route path="/usuarios" element={
            <ProtectedRoute>
              <GestaoUsuarios />
            </ProtectedRoute>
          } />
          <Route path="/relatorios" element={
            <ProtectedRoute>
              <Relatorios />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </>
  );
}

export default App;